import { render, staticRenderFns } from "./ListActiveDetailDep.vue?vue&type=template&id=70b2e332&scoped=true&"
import script from "./ListActiveDetailDep.vue?vue&type=script&lang=js&"
export * from "./ListActiveDetailDep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b2e332",
  null
  
)

export default component.exports